// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._5tnLgkknIlwzsTLGeuMw{
    background-color: white !important;
}

.WfdMeviCZzJWS43exBV5 {
    overflow: hidden;
}

.FAm2hWo1YiVGw_Db7r5n {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    font-size: 0.8rem;
    margin-bottom: 4px;
}

.lnFJJiakedOKk4xW2iM6 {
    margin-left: 0px !important;
    margin-top: 4px;
}`, "",{"version":3,"sources":["webpack://./src/plugins/widen-library/admin/src/components/AssetCard.module.css"],"names":[],"mappings":"AAAA;IACI,kCAAkC;AACtC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;IAC3B,eAAe;AACnB","sourcesContent":[".card-asset{\n    background-color: white !important;\n}\n\n.card-content {\n    overflow: hidden;\n}\n\n.card-title {\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n    font-size: 0.8rem;\n    margin-bottom: 4px;\n}\n\n.card-badge {\n    margin-left: 0px !important;\n    margin-top: 4px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card-asset": `_5tnLgkknIlwzsTLGeuMw`,
	"card-content": `WfdMeviCZzJWS43exBV5`,
	"card-title": `FAm2hWo1YiVGw_Db7r5n`,
	"card-badge": `lnFJJiakedOKk4xW2iM6`
};
export default ___CSS_LOADER_EXPORT___;
